import Component from '@glimmer/component';
import { localCopy } from 'tracked-toolbox';

const TOOLTIP_TEXT = 'Global sign-in flow';

export default class GlobalFlowIcon extends Component {
  @localCopy('args.tooltipText', TOOLTIP_TEXT) tooltipText;
  @localCopy('args.show', true) show;
}
